//const moment = require('moment');
//require('moment/locale/kz');
//require('moment/locale/ru');
//require('moment/locale/en');
//moment.locale('kz');
// moment.locale('en-US');
// moment.locale('ru');

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import 'dayjs/locale/en'
import 'dayjs/locale/kk'
dayjs.locale('ru')
dayjs.locale('en')
dayjs.locale('kk')